<template>
  <div class="shopsetting">
    <LeoHandB title="店铺中心" curactive="setting">
      <div slot="content">
        <div class="setting-shop" :style="{ background: `linear-gradient(${gcfg.BackgroundColor} 50%,#FFF)` }">
          <div class="shop-xx shop-setting" v-if="store != null && store != undefined"
            :style="'background-color:' + gcfg.BackgroundColor">
            <div class="shop-tx">
              <img :src="store.avatar">
            </div>
            <div class="shop-xq" :style="'color:#545659'">
              <div class="shop-name" @click="goSettingPage">
                <p class="name-p">
                  <span class="name ells2">{{ store.storename }}</span>
                </p>
                <p class="name">
                  <span class="name ells2">ID:{{ store.id }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="swipemain" :style="'color:' + gcfg.TopTextColor">
            <!-- 系统公告  -->
            <van-swipe style="height: 100px;" :autoplay="3000" :vertical="true" :show-indicators="false">
              <van-swipe-item v-for="(itemlist, key) in list" :key="key">
                <template v-for="(item, index) in itemlist">
                  <div :key="index" class="text-content van-ellipsis" @click="gotourl(item)">
                    <span>{{ item.title }}</span>
                  </div>
                </template>
              </van-swipe-item>
            </van-swipe>
          </div>
          <van-grid :style="'color:' + gcfg.TopTextColor" class="grid-box" clickable :column-num="3" :border="false">
            <van-grid-item @click="openYeTx">
              <van-icon name="gold-coin-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">余额提现</span>
            </van-grid-item>
            <van-grid-item to="incomedetails">
              <van-icon name="balance-list-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">收益明细</span>
            </van-grid-item>
            <van-grid-item @click="goNewShop()">
              <van-icon name="new-arrival-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">新品</span>
            </van-grid-item>
            <van-grid-item to="shopmanage">
              <van-icon name="send-gift-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">商品管理</span>
            </van-grid-item>
            <van-grid-item @click="onQrshow">
              <van-icon name="qr" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">店铺码</span>
            </van-grid-item>
            <van-grid-item @click="goSettingPage">
              <van-icon name="setting-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" :style="'color:' + gcfg.TopTextColor">设置</span>
            </van-grid-item>
          </van-grid>
          <!-- </div> -->
          <div class="ddbox field-shopxx">
            <div class="dditem">
              <p>
                <span>{{ dataitem.waitIncome }}</span>
                <span>待审核收益(元)</span>
              </p>
            </div>
            <div class="dditem">
              <p>
                <span>{{ dataitem.finishIncome }}</span>
                <span>累计赚取(元)</span>
              </p>
            </div>
          </div>
        </div>
        <div class="leoshop-content" style="margin-top: 20px;">
          <div class="ddbox">
            <van-cell title="我的订单" is-link value="全部" @click="goOder('0')" />
            <van-grid clickable :column-num="4" :border="false">
              <van-grid-item @click="goOder('1')">
                <van-badge>
                  <template #content v-if="orderGroup.NoConfirmNum > 0">{{ orderGroup.NoConfirmNum }}</template>
                  <van-icon class="van-grid-item__icon" name="paid" />
                </van-badge>
                <span class="van-grid-item__text">待确认</span>
              </van-grid-item>
              <van-grid-item @click="goOder('2')">
                <van-badge>
                  <template #content v-if="orderGroup.NoPayNum > 0">{{ orderGroup.NoPayNum }}</template>
                  <van-icon class="van-grid-item__icon" name="pending-payment" />
                </van-badge>
                <span class="van-grid-item__text">待支付</span>
              </van-grid-item>
              <van-grid-item @click="goOder('3')">
                <van-badge>
                  <template #content v-if="orderGroup.NoUseNum > 0">{{ orderGroup.NoUseNum }}</template>
                  <van-icon name="records" class="van-grid-item__icon" />
                </van-badge>
                <span class="van-grid-item__text">待核销</span>
              </van-grid-item>
              <van-grid-item @click="goOder('4')">
                <van-badge>
                  <template #content v-if="orderGroup.FinishNum > 0">{{ orderGroup.FinishNum }}</template>
                  <van-icon class="van-grid-item__icon" name="sign" />
                </van-badge>
                <span class="van-grid-item__text">已完成</span>
              </van-grid-item>
            </van-grid>
          </div>
          <div>
            <div class="no-ddbox">
              <van-image height="110" :src="imgShare" @click="onQrcode" />
            </div>
            <div class="ddbox">
              <van-cell title="我的分销" />
              <van-grid clickable :column-num="4" :border="false">
                <van-grid-item to="dissetting?n=1">
                  <van-badge>
                    <van-icon class="van-grid-item__icon" name="descending" />
                  </van-badge>
                  <span class="van-grid-item__text">我的下级</span>
                </van-grid-item>
                <van-grid-item to="disordernew?n=1">
                  <van-badge>
                    <van-icon class="van-grid-item__icon" name="orders-o" />
                  </van-badge>
                  <span class="van-grid-item__text">分销订单</span>
                </van-grid-item>
                <van-grid-item to="dissy?n=1">
                  <van-badge>
                    <van-icon name="balance-o" class="van-grid-item__icon" />
                  </van-badge>
                  <span class="van-grid-item__text">分销收益</span>
                </van-grid-item>
                <!--								<van-grid-item to="dissetting?n=3">
									<van-badge>
										<van-icon class="van-grid-item__icon" name="setting-o" />
									</van-badge>
									<span class="van-grid-item__text">分销设置</span>
                </van-grid-item>-->
              </van-grid>
            </div>
          </div>
        </div>
      </div>
    </LeoHandB>
    <van-popup v-model="qrshow" round style="width: 280px;">
      <div class="qrshow">
        <van-image :src="qrimg" />
      </div>
    </van-popup>
    <van-popup v-model="txshow" round style="width: 280px;">
      <div class="qrshow">
        <div class="titlebox">
          <p class="title">余额提现</p>
          <p class="right-icon" @click="txshow = false">
            <van-icon name="close" />
          </p>
        </div>
        <div class="leftt">
          <p>
            可提现金额：
            <span>{{ maxprice }}</span>元
          </p>
        </div>
        <van-form @submit="onSubmitTx">
          <!-- 允许输入正整数，调起纯数字键盘 -->
          <van-field v-model="digit" name="digit" type="digit" label="提现金额￥" :colon="true" placeholder="请输入提现金额"
            @input="validator" :error-message="errpricemsg" />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>

    <!-- <van-popup v-for="(item, i) in ggShow1" :key="i" :overlay="i == 0" v-model="item.show" class="gg-popup"
      @close="ggClose1(i)" :close-on-click-overlay="false" style="width: 70%;">
      <div class="cc-qq">
        <div class="title" v-if="item.title">
          <p>{{ item.title }}</p>
        </div>
        <div class="gg-content" v-if="item.content">
          <div v-html="item.content"></div>
        </div>
      </div>
      <div class="qq-clode">
        <van-icon name="close" @click="ggClose1(i)" />
      </div>
    </van-popup> -->
    <van-popup v-for="(item, i) in ggShow1" :key="'popup' + i" :overlay="i == 0" v-model="item.show" class="gg-popup"
      @close="ggClose1(i)" :close-on-click-overlay="false" style="width: 70%;">
      <div class="cc-qq">
        <div class="title" v-if="item.title">
          <p>{{ item.title }}</p>
        </div>
        <div class="gg-content" v-if="item.content">
          <div v-html="item.content"></div>
        </div>
        <div class="notice-footer">
          <van-checkbox v-model="item.checked" class="no-popup" shape="square" @change="noticeOnChange(item)"
            icon-size="14px">
            30日内不再弹出
          </van-checkbox>
        </div>
      </div>
      <div class="qq-clode">
        <van-icon name="close" @click="ggClose1(i)" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import CubePage from "../TP/cube-page.vue";
import LeoHandB from "../TP/LeoHandB.vue";
import * as util from "@/utils/network";
import { Dialog, Toast } from "vant";
import { redirect } from "@/utils/network";
export default {
  components: {
    CubePage,
    LeoHandB
  },
  data() {
    return {
      digit: "",
      qrshow: false, //二维码弹出层
      txshow: false, //收益体现弹出层
      gcfg: [],
      list: [],
      maxprice: 0,
      errpricemsg: "",
      dataitem: {},
      orderGroup: {},
      store: null,
      qrimg: "", //店铺二维码
      storeid: this.$route.query.store_id,
      imgShare: null,
      isShow: this.$route.query.show,
      show: true,
      ggShow1: [],
    };
  },
  created() {
    this.getGg();
    this.getShareImages();
    this.gcfg = this.$store.getters.getGcfg;
    // this.store = this.$store.getters.getShop
    this.getData(), this.getSysNotice();
  },
  methods: {
    onQrcode() {
      this.$router.push({
        path: "/qrcode",
        query: {
          n: 1
        }
      });
    },
    getShareImages() {
      let that = this;
      var url = "/addons/litestore/api.store/getShareImages";
      //这里直接调用网络接口
      util.get(url, {},
        function (result) {
          if (result.data != null) {
            that.imgShare = result.data.share_img;
          }
        }, function (result) {
          /*console.error('error',result);
          return false;*/
          var path = result.data.path ? result.data.path : "my";
          console.log('path', path)
          redirect(path);
        }
      );
    },
    goDisOder() {
      this.$router.push({
        path: "/disorder",
        query: {
          showType: 0
        }
      });
    },
    openYeTx() {
      this.txshow = true;
      this.getPrice();
    },
    goOder(v) {
      this.$router.push({
        name: "LeoOrder",
        params: {
          showType: v
        }
      });
    },
    // 二维码打开
    onQrshow() {
      let that = this;
      that.qrimg = "";
      var url = "/addons/litestore/api.store/qrcode";
      let id = that.storeid ? that.storeid : this.$store.getters.getShop;
      //这里直接调用网络接口
      util.get(
        url,
        {
          store_id: id
        },
        function (result) {
          that.qrimg = result.data;
          that.qrshow = true;
        }
      );
    },
    goDetail(val) {
      this.$router.push({
        path: "shopsetting/leoorder",
        query: {
          showType: val
        }
      });
    },
    // 提现
    onSubmitTx(v) {
      let that = this;
      if (that.errpricemsg != "") {
        Toast(that.errpricemsg);
        return;
      }
      var url = "/addons/litestore/api.store/extract";
      let id = that.storeid ? that.storeid : this.$store.getters.getShop;
      //这里直接调用网络接口
      util.post(
        url,
        {
          store_id: id,
          amount: that.digit
        },
        function (result) {
          Dialog.alert({
            title: "温馨提示",
            message: result.msg
          }).then(() => {
            that.txshow = false;
            that.getData();
          });
          that.digit = "";
          // Toast(result.msg);
        }
      );
    },
    // 验证提现金额
    validator(val) {
      let that = this;
      if (val > 500) {
        that.errpricemsg = "最大提现金额500元/次";
        return;
      }
      that.errpricemsg = "";
    },
    //设置页面
    goSettingPage() {
      this.$router.push({
        name: "ShopXqSetting",
        params: {
          item: this.store
        }
      });
    },
    // 获取体现金额
    getPrice() {
      var url = "/addons/litestore/api.store/extract";
      let that = this;
      let id = that.storeid ? that.storeid : this.$store.getters.getShop;
      //这里直接调用网络接口
      util.get(
        url,
        {
          store_id: id
        },
        function (result) {
          that.maxprice = result.data;
        }
      );
    },
    // 获取数据
    getData() {
      var url = "/addons/litestore/api.store/index";
      let that = this;
      let id = that.storeid ? that.storeid : this.$store.getters.getShop;
      //util.isToken(that.store);
      //这里直接调用网络接口
      util.get(
        url,
        {
          store_id: id
        },
        function (result) {

          //console.log(result);
          that.dataitem = result.data;
          that.orderGroup = result.data.orderGroup;
          that.store = result.data.store;
          that.$store.commit("setShop", result.data.store.id);
        },
        function fail(result) {
          /*console.error('error',result);
              return false;*/
          var path = result.data.path ? result.data.path : "my";
          console.log('path', path)
          redirect(path);
        }
      );
    },
    //获取公告
    getSysNotice() {
      let that = this;
      var url = "/addons/litestore/api.index/getSysNotice";
      //这里直接调用网络接口
      let store_id = that.storeid ? that.storeid : this.$store.getters.getShop;
      util.get(
        url,
        {
          place: 104,
          store_id: store_id
        },
        function (result) {
          that.list = result;
        }
      );
    },
    // 公告跳转
    gotourl(item) {
      console.log(item);
      if (item.url) {
        window.location.href = item.url;
      } else {
        this.$router.push({
          path: "about",
          query: {
            id: item.id
          }
        });
      }
    },
    ggClose1(i) {
      this.ggShow1[i].show = false;
    },
    async getGg() {
      var url = "/addons/litestore/api.index/notice";
      let that = this;
      that.ggShow1 = [];
      //这里直接调用网络接口
      await util.get(
        url,
        {
          type: 1,
          place: 104
        },
        //30 * 24 * 60 * 60 * 1000;
        function (res) {
          res.data.forEach(item => {
            that.ggShow1.push({
              title: item.title,
              content: item.content,
              id: item.id,
              show: true
            });
          });
        }
      );
    },
    // 创建一个函数来处理逻辑
    processArrays(aArray, bArray) {
      const currentTime = Date.now();
      const thirtyDays = 30 * 24 * 60 * 60 * 1000;

      const bMap = new Map();

      bArray.forEach(bItem => {
        const timeDiff = currentTime - bItem.time;

        if (timeDiff > thirtyDays) {
          bItem.time = Date.now();
          bItem.checked = false;
        }

        if (timeDiff <= thirtyDays) {
          bMap.set(bItem.id, bItem.checked);
        }
      });

      const processedA = aArray.map(aItem => {
        const isChecked = bMap.get(aItem.id) || false;

        return {
          ...aItem,
          checked: isChecked,
          show: isChecked ? false : true,
          isValid: bMap.has(aItem.id)
        };
      });

      return {
        a: processedA,
        b: bArray
      };
    },
    // 点击不再弹出
    noticeOnChange(item) {
      const url = "/addons/litestore/api.index/closeNotice";
      util.post(url, { id: item.id });
    },
    goNewShop() {
      this.$router.push({
        path: '/xpsj',
        query: {
          isNewShop: 'new'
        }
      })
    }
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg;
    }
  }
};
</script>
<style>
.van-grid-item__content,
.van-cell {
  background: transparent;
  border: none;
}

/* 添加这段样式后，Primary Button 会变成红色 */
:root {
  --van-grid-item-text-color: gcfg.TopTextColor;
}
</style>
<style lang="less" scoped="scoped">
@import url("../../assets/css/listboxless.less");

.setting-shop {
  position: relative;
  height: auto;

  .ddbox {
    margin: 10px 0;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 0 5px #e2e2e2;

    .dditem {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 60px;

      p {
        text-align: center;

        span {
          display: block;
          font-size: 13px;
        }

        span:first-child {
          font-size: 20px;
          font-weight: 600;
        }

        .sizesm {
          font-size: 12px;
          color: #aaabaf;
        }
      }
    }
  }

  .field-shopxx {
    height: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .dditem {
      span:first-child {
        color: rgb(255, 0, 0);
        font-weight: 600;
      }
    }
  }
}

.shop-name .name-p {
  margin-bottom: 10px;
}

.grid-box {
  background: #fff;
  border-radius: 5px;
  margin: 15px 0;
  box-shadow: 0 0 5px #e2e2e2;
}

.no-ddbox {
  padding-bottom: 10px;
  margin: 10px 10px 0;
}

.swipemain {
  width: auto;
  text-align: left;
  border-radius: 5px;
  margin: 10px 0;
  padding: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 5px #e2e2e2;
}

.text-content {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

.text-content {
  font-size: 14px;
  color: #333;
  padding: 0;
}

/deep/ .van-swipe {
  margin: 0;
  padding: 0;
  height: 90px;
  overflow: hidden;
}

/deep/ .van-swipe__indicator {
  background-color: #333;
}

.leoshop-content .ddbox {
  margin: 10px 15px 0;
}

.gg-popup {
  background: transparent;
  min-width: 70%;
  max-width: 90%;

  .cc-qq {
    border-radius: 10px;
    background-color: #fff;

    .title {
      padding: 8px 10px;
      font-size: 14px;
      background-color: #ff8a3a;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      color: #fff;

      p {
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .van-row {
      padding: 0 15px;
      margin-top: 10px;

      .van-col--12 {
        .van-image {
          height: 156px;
        }
      }

      .van-col--8 {
        .van-image {
          height: 102px;
        }
      }
    }

    .imgs {
      display: flex;

      .van-image+.van-image {
        margin-left: 10px;
      }
    }

    .gg-content {
      //max-height: 480px;
      height: 400px;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: scroll;
      font-size: 13px;
      line-height: 22px;
    }
  }

  .qq-clode {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;

    .van-icon {
      color: #fff;
      font-size: 28px;
    }
  }
}

.notice-footer {
  padding: 10px 0 20px;
  display: flex;
  justify-content: center;

  .ok {
    background-color: #6D189E;
    color: #fff;
    font-size: 12px;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 8px 20px;
    margin: 0 15px;
    border-radius: 4px;
  }

}
</style>
